import DPDropDown from 'framework/components/DPDropDown'
import DPSearchBoxDynamic from 'framework/components/DPSearchBoxDynamic'
import DPSwitch from 'framework/components/DPSwitch'
import DPTextBox from 'framework/components/DPTextBox'
import DPTextBoxforgrid from 'framework/components/DPTextBoxforgrid'
import { Text } from 'framework/validators/TextValidation'
import React, { useState, useEffect } from 'react'
import ReactPaginate from 'react-paginate'
import { Link } from "react-router-dom"
import {
    Col,
    Row,
    Button,
    Label,
} from 'reactstrap'
import { GetUserWiseLocations } from './BinController'


const BinContent = ({
    modal_xlarge_product,
    tog_xlarge_product,
    modeal_xlarge_location,
    tog_xlarge_location,
    GetSelectedProduct,
    GetSelectedLocation,
    menuCode,
    productCode,
    SetProductCode,
    locationCode,
    SetLocationCode,
    allLocation,

    SetTxnCode,
    txnCode,
    txnList,
    locationOnBlur,
    productOnBlur,
    SetAllTxn,
    allTxn,
    fromDate,
    toDate,
    setFromDate,
    setToDate,
    bincardData,
    RetreveData,
    generateDisable,
    displayAlertMessage,
    triggerClear,
    productDesc,
    getProductDescription,
    ExportData
}) => {

    const [groupFilter, SetGroupFilter] = useState("a")
    const [pageNo, setPageNo] = useState(1);
    const [pageSize, setPageSize] = useState(5);
    const ApiURL = window.Links.ApiURL
    const [allLocations, setAllLocations] = useState([])


    useEffect(() => {
        setPageNo(1)

    }, [bincardData])

    useEffect(async () => {

        var obj = JSON.parse(localStorage.getItem("authUser"))
        var LogUserType = obj[2]
        var LocationCode = obj[3]
        const { success, data } = await GetUserWiseLocations(LogUserType, LocationCode);
        if (success) {
            setAllLocations(data)
        } else {
            setAllLocations([])
        }
    }, [])

    useEffect(() => {
        setPageSize(5)
        setPageNo(1)
    }, [triggerClear])



    const defaultSorted = [{
        dataField: 'id',
        order: 'asc'
    }];


    const indexOfLastPost = pageNo * pageSize
    const indexOfFirstPost = indexOfLastPost - pageSize
    const currentGroupRows = bincardData.slice(indexOfFirstPost, indexOfLastPost)

    const handlePageClick = (event) => {
        setPageNo(event.selected + 1);
    };

    return (
        <React.Fragment>
            <Row>
                <Col sm={12} md={6} className="mb-4-sm">
                    <Row>
                        <Col sm={12} md={8} className="mb-4-sm">
                            <DPDropDown
                                labelText={"Location"}
                                optionGroup={allLocations}
                                selectedGroup={locationCode}
                                onChange={(e) => {
                                    SetLocationCode(e["value"])
                                }}
                                disabled={allLocation}
                            />
                        </Col>
                    </Row>

                    <Row>
                        <Col sm={12} md={8} className="mb-4-sm">
                            <DPTextBox
                                labelText={"Product"}
                                value={productCode}
                                onChange={(e) => {
                                    let val2 = Text(e.target, 30, true, true, "any", true)
                                    SetProductCode(val2)
                                }}
                                onBlur={(e) => {
                                    getProductDescription(e.target.value)
                                }}
                                disabled={locationCode == "" ? true : false}
                            // onBlur={productOnBlur}

                            />
                        </Col>
                        <Col sm={12} md={1} className="mb-4-sm">
                            <Button
                                onClick={() => {
                                    if (locationCode == "") {
                                        displayAlertMessage("danger", "Please select location first")
                                        return
                                    }
                                    tog_xlarge_product()
                                }}
                                color="success"
                                className="btn-sm"
                                disabled={locationCode == "" ? true : false}

                            >
                                <i
                                    className="mdi mdi-search-web"
                                    style={{ fontSize: "12px" }}
                                ></i>
                            </Button>
                        </Col>
                    </Row>
                    <Row>
                        <Col sm={12} md={8} className="mb-4-sm">
                            <DPTextBox
                                labelText={"Product Description"}
                                value={productDesc}
                                disabled={true}
                            />
                        </Col>

                    </Row>

                    <Row>

                        <Col sm={12} md={8} className="mb-4-sm">

                            <DPDropDown
                                labelText={"Transaction"}
                                optionGroup={txnList}
                                selectedGroup={txnCode}
                                onChange={(e) => {
                                    SetTxnCode(e["value"])
                                }}
                                disabled={allTxn}
                            />

                        </Col>
                        <Col sm={12} md={1} className="mb-4-sm">

                        </Col>
                        <Col sm={12} md={1} className="mb-4-sm">
                            <Label
                                htmlFor="example-text-input"
                                className={`col-md-12 col-form-label-sm`}
                            >
                                All
                            </Label>
                        </Col>
                        <Col sm={12} md={2} className="mb-4-sm">
                            <DPSwitch
                                checked={allTxn}
                                onChange={(e) => {
                                    SetTxnCode("")
                                    SetAllTxn(e)
                                }}
                            />
                        </Col>
                    </Row>

                    <Row>
                        <Col sm={12} md={2} className="mb-4-sm">
                            <Label
                                htmlFor="example-text-input"
                                className={`col-md-12 col-form-label-sm`}
                            >
                                Date From
                            </Label>
                        </Col>
                        <Col sm={12} md={3} className="mb-4-sm">
                            <DPTextBoxforgrid
                                value={fromDate}
                                textType={"date"}
                                onChange={(e) => {
                                    setFromDate(e.target.value)
                                }}
                            />
                        </Col>
                        <Col sm={12} md={1} className="mb-4-sm">
                            <Label
                                htmlFor="example-text-input"
                                className={`col-md-12 col-form-label-sm`}
                            >
                                To
                            </Label>
                        </Col>
                        <Col sm={12} md={3} className="mb-4-sm">
                            <DPTextBoxforgrid
                                value={toDate}
                                textType={"date"}
                                onChange={(e) => {
                                    setToDate(e.target.value)
                                }}
                            />
                        </Col>
                    </Row>
                    <DPSearchBoxDynamic
                        searchData={[]}
                        columns={[]}
                        defaultSorted={defaultSorted}
                        mainTitle={"Location Search"}
                        SelectType={"checkbox"} //checkbox for multipe, radio for single, ROW_SELECT_DISABLED for disable
                        isOpen={modeal_xlarge_location}
                        toggle={tog_xlarge_location}
                        getSelect={GetSelectedLocation}
                        APIURL={ApiURL}
                        URLPath={"LOCATION"}
                        MenuCode={menuCode}
                        KeyVal={"LOC"}
                        searchBy={"LOC_CODE"}
                        FilterStr={groupFilter}
                    />

                    <DPSearchBoxDynamic
                        searchData={[]}
                        columns={[]}
                        defaultSorted={defaultSorted}
                        mainTitle={"Product Search"}
                        SelectType={"checkbox"} //checkbox for multipe, radio for single, ROW_SELECT_DISABLED for disable
                        isOpen={modal_xlarge_product}
                        toggle={tog_xlarge_product}
                        getSelect={GetSelectedProduct}
                        APIURL={ApiURL}
                        URLPath={"PRODUCT"}
                        MenuCode={menuCode}
                        KeyVal={"PRO"}
                        searchBy={"IPLU_PRODUCTCODE"}
                        FilterStr={" AND IPLU_LOCCODE = '" + locationCode + "'"}
                    />

                </Col>
            </Row>
            <Row>
                <Col sm={12} md={6} className="mb-4-sm">
                  <Row className='mx-1'>
                        <Button color="primary" className="btn-sm py-2 my-2" disabled={generateDisable} onClick={RetreveData}>Load Bincard Data</Button>
                    </Row>

                </Col>

                <Col sm={12} md={6} className="mb-4-sm">
                    <Row className='mx-1'>
                        <Button color="success" className="btn-sm py-2 my-2" onClick={ExportData}>Download Bincard Data</Button>
                    </Row>

                </Col>
            </Row>
            <Row>
                <div style={{
                    overflowX: 'auto',
                    width: '100%',
                    display: 'block',
                    whiteSpace: 'nowrap',
                    position: 'relative'
                }}>
                    <table className="table table-bordered  table-sm">
                        <thead className='table-secondary'>
                            <tr>
                                <th>#</th>
                                <th>Date</th>
                                <th>Transaction</th>
                                <th>Reference No</th>
                                <th>From Loc</th>
                                <th>To Loc</th>
                                <th>Supplier/Customer</th>
                                <th>Line Remark</th>
                                <th title='Cost Price' style={{ textAlign: "right" }}>Cost</th>
                                <th title='Selling Price' style={{ textAlign: "right" }}>Selling</th>
                                <th title='Average Cost' style={{ textAlign: "right" }}>AVG Cost</th>
                                <th style={{ textAlign: "right" }}>In Qty</th>
                                <th style={{ textAlign: "right" }}>Out Qty</th>
                                <th style={{ textAlign: "right" }}>Running Balance</th>
                            </tr>
                        </thead>
                        <tbody>
                            {currentGroupRows.map((row, index) => {
                                // Calculate the running balance for each row
                                // const inQty = parseFloat(row["BINCARD_QTYIN"]) || 0;
                                // const outQty = parseFloat(row["BINCARD_QTYOUT"]) || 0;
                                return (
                                    <tr key={index}>
                                        <td style={{ width: '20px' }}>{indexOfFirstPost + index + 1}</td>
                                        <td style={{ width: '80px' }}>{row["BINCARD_DATE"].slice(0, 10)}</td>
                                        <td style={{ width: '150px' }}>{"[" + row["BINCARD_TRNTYPE"] + "] " + row["BINCARD_DESC"]}</td>
                                        {row.BINCARD_TRNTYPE != "INV" ? <td style={{ width: '100px' }}><Link to={`/Transaction?${row.BINCARD_TRNTYPE}&${row.BINCARD_DOCNO}`} target="_blank" >{row["BINCARD_DOCNO"]}</Link></td> : <td style={{ width: '100px' }}>{row.BINCARD_DOCNO}</td>}
                                        {/* {row.BINCARD_TRNTYPE != "INV" ? <td><Link to={`/Transaction?${row.BINCARD_TRNTYPE}&${row.BINCARD_DOCNO}`} target="_blank" >{row.BINCARD_DOCNO}</Link></td> : <td>{row.BINCARD_DOCNO}</td>} */}
                                        <td style={{ width: '50px', textAlign: "left" }}>{(row["BINCARD_FROM"])}</td>
                                        <td style={{ width: '50px', textAlign: "left" }}>{(row["BINCARD_TO"])}</td>
                                        <td style={{ width: '50px', textAlign: "left" }}>{(row["BINCARD_SUPCUS"])}</td>
                                        <td style={{ width: '50px', textAlign: "left" }}>{(row["BINCARD_LINEREMARK"])}</td>
                                        <td style={{ width: '50px', textAlign: "right" }}>{(row["BINCARD_CPRICE"])}</td>
                                        <td style={{ width: '50px', textAlign: "right" }}>{row["BINCARD_SPRICE"]}</td>
                                        <td style={{ width: '50px', textAlign: "right" }}>{row["BINCARD_APRICE"]}</td>
                                        <td style={{ width: '50px', textAlign: "right" }}>{row["BINCARD_QTYIN"]}</td>
                                        <td style={{ width: '50px', textAlign: "right" }}>{row["BINCARD_QTYOUT"]}</td>
                                        <td style={{ width: '50px', textAlign: "right" }}>{parseFloat((bincardData.slice(0, indexOfFirstPost + index + 1).reduce((a, b) => a + parseFloat(b.BINCARD_QTYIN), 0)) - (bincardData.slice(0, indexOfFirstPost + index + 1).reduce((a, b) => a + parseFloat(b.BINCARD_QTYOUT), 0))).toFixed(4)}</td>
                                    </tr>
                                );
                            })}
                        </tbody>
                        <tfoot>
                            <tr>
                                <td colSpan="11" style={{ textAlign: "right" }}>Total</td>
                                <td style={{ textAlign: "right" }}>{parseFloat((bincardData.reduce((a, b) => a + parseFloat(b.BINCARD_QTYIN), 0))).toFixed(4)}</td>
                                <td style={{ textAlign: "right" }}>{parseFloat((bincardData.reduce((a, b) => a + parseFloat(b.BINCARD_QTYOUT), 0))).toFixed(4)}</td>
                                <td style={{ textAlign: "right" }}>{parseFloat((bincardData.reduce((a, b) => a + parseFloat(b.BINCARD_QTYIN), 0)) - (bincardData.reduce((a, b) => a + parseFloat(b.BINCARD_QTYOUT), 0))).toFixed(4)}</td>
                            </tr>
                        </tfoot>
                    </table>
                </div>
            </Row>
            <Row className='pb-20'>
                <Col sm={12} md={1} className="mb-4-sm">
                    <Label
                        htmlFor="example-text-input"
                        className={`col-md-12 col-form-label-sm`}
                    >
                        Page Size
                    </Label>
                </Col>
                <Col sm={12} md={2} className="mb-4-sm">
                    <DPDropDown
                        labelText={"Rows Per Page"}
                        labelHide={true}
                        rowClass={"col-md-6"}
                        optionGroup={[{ value: 5, label: "5" }, { value: 10, label: "10" }, { value: 20, label: "20" }, { value: 50, label: "50" }, { value: 100, label: "100" }]}
                        selectedGroup={pageSize}
                        onChange={(e) => {
                            setPageSize(e["value"])
                            setPageNo(1)
                        }}
                    />
                </Col>
                <Col sm={12} md={9} className="mb-4-sm">
                    <ReactPaginate
                        previousLabel={'Previous'}
                        nextLabel={'Next'}
                        breakLabel={'...'}
                        pageClassName="page-item"
                        pageLinkClassName="page-link"
                        previousClassName="page-item"
                        previousLinkClassName="page-link"
                        nextClassName="page-item"
                        nextLinkClassName="page-link"
                        breakClassName="page-item"
                        breakLinkClassName="page-link"
                        pageCount={Math.ceil(bincardData.length / pageSize)}
                        pageRangeDisplayed={2}
                        onPageChange={handlePageClick}
                        forcePage={pageNo - 1}
                        renderOnZeroPageCount={null}
                        activeClassName={'active'}
                        activeLinkClassName={'page-link'}
                        containerClassName={'pagination justify-content-end pagination-sm'}

                    />
                </Col>
            </Row>
            <Row >
                <br></br>
                <br></br>
                <br></br>
                <br></br>
                <br></br>
                <br></br>
            </Row>
        </React.Fragment>
    )
}
export default BinContent